import { render, staticRenderFns } from "./Factory.vue?vue&type=template&id=2a9ef69c&scoped=true&"
import script from "./Factory.vue?vue&type=script&lang=js&"
export * from "./Factory.vue?vue&type=script&lang=js&"
import style0 from "./Factory.vue?vue&type=style&index=0&id=2a9ef69c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9ef69c",
  null
  
)

export default component.exports